var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"chart-container",attrs:{"title":_vm.title}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }